import { FC, useMemo } from 'react';
import FormControl from '@mui/material/FormControl';
import Select, { SelectProps } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { useDictionary } from '@cvt/hooks/useDictionary';
import { getStatusOptions } from '@modules/Stories/helpers/story';


type Props = SelectProps<Stories.StoryStatus | ''> & {
  fullWidth?: boolean,
  showEmpty?: boolean,
}

export const StatusSelect: FC<Props> = ({ fullWidth, showEmpty = true, ...props }) => {
  const dictionary = useDictionary();
  const statusOptions = useMemo(() => getStatusOptions(dictionary), [dictionary]);

  return (
    <FormControl fullWidth={fullWidth}>
      <Select displayEmpty defaultValue="" sx={{ minWidth: 136 }} {...props}>
        {showEmpty && (
          <MenuItem value="">
            <span style={{ color: '#a2a2a2' }}>
              {dictionary.forms.story.status.all}
            </span>
          </MenuItem>
        )}
        {statusOptions.map(({ value, label }) => (
          <MenuItem key={value} value={value}>{label}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
